import { AMONTE, MONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';

export default function genererCritereRechercheDispositif() {
  return {
    auto: '',
    codes: [],
    types: [],
    supports: [],
    etats: [MONTE, AMONTE],
    adresse: null,
    villes: [],
    agglomerations: [],
    datesMontage: null,
    datesDemontage: null,
    agencesId: [],
    actif: true,
    codesPostaux: [],
    avecCoordonnees: null,
    clientIds: [],
    clients: [],
    tagIds: [],
    arretsBus: [],
    marqueIds: [],
    tempsFort: null,
    secteurs: [],
    hasSecteur: null,
    exclureVille: [],
  };
}
